import React from 'react';

// Lightweight, consistent line-icon set drawn with currentColor.
// Replaces emoji across the site for a cleaner, more professional look.
const paths = {
  leaf: (
    <>
      <path d="M11 20A7 7 0 0 1 4 13C4 8 8 4 20 4C20 14 16 20 11 20Z" />
      <path d="M5 19C8 14 12 12 17 11" />
    </>
  ),
  sugarFree: (
    <>
      <path d="M12 3C8.5 7 7 10 7 13a5 5 0 0 0 10 0c0-3-1.5-6-5-10Z" />
      <path d="M4 4 20 20" />
    </>
  ),
  egg: (
    <>
      <path d="M12 3c3.5 0 6 5 6 9a6 6 0 0 1-12 0c0-4 2.5-9 6-9Z" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 5 6v5c0 4 3 7 7 9 4-2 7-5 7-9V6l-7-3Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3v6m0 6v6m9-9h-6m-6 0H3" />
      <path d="M12 9a3 3 0 0 0 3 3 3 3 0 0 0-3 3 3 3 0 0 0-3-3 3 3 0 0 0 3-3Z" />
    </>
  ),
  slab: (
    <>
      <rect x="3" y="7" width="18" height="10" rx="2" />
      <path d="M3 11h18M9 7v10M15 7v10" />
    </>
  ),
  gift: (
    <>
      <rect x="4" y="9" width="16" height="11" rx="1.5" />
      <path d="M4 13h16M12 9v11" />
      <path d="M12 9c-1-3-5-4-5-1.5C7 9 10 9 12 9Zm0 0c1-3 5-4 5-1.5C17 9 14 9 12 9Z" />
    </>
  ),
  star: (
    <>
      <path d="m12 3 2.6 5.5L20 9.3l-4 4 1 5.7-5-2.9-5 2.9 1-5.7-4-4 5.4-.8L12 3Z" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-5.5 7-11a7 7 0 0 0-14 0c0 5.5 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  phone: (
    <>
      <path d="M6 3h3l2 5-2.5 1.5a11 11 0 0 0 5 5L16 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 4 5a2 2 0 0 1 2-2Z" />
    </>
  ),
  instagram: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="4.5" />
      <circle cx="12" cy="12" r="3.5" />
      <circle cx="17" cy="7" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  whatsapp: (
    <>
      <path d="M4 20l1.4-4A8 8 0 1 1 9 19.2L4 20Z" />
      <path d="M9 9.5c0 3 2.5 5.5 5.5 5.5.6 0 1-.4 1-1 0-.3-.6-1-1.2-1.2-.5-.2-.8.4-1.1.4-.8 0-2.8-2-2.8-2.8 0-.3.6-.6.4-1.1C10.5 9 9.8 8.5 9.5 8.5c-.6 0-.5.6-.5 1Z" fill="currentColor" stroke="none" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </>
  ),
  cart: (
    <>
      <path d="M5.5 7h13l-1.1 8.4a2 2 0 0 1-2 1.6H8.6a2 2 0 0 1-2-1.6L5.5 7Z" />
      <path d="M9 7a3 3 0 0 1 6 0" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
};

const Icon = ({ name, size = 20, strokeWidth = 1.6, className = '', style }) => {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      className={`icon icon-${name} ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      aria-hidden="true"
    >
      {content}
    </svg>
  );
};

export default Icon;
